var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 133,
    viewBox: "0 0 154 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77 11.0834C41.58 11.0834 12.8334 35.91 12.8334 66.5C12.8334 97.09 41.58 121.917 77 121.917C112.42 121.917 141.167 97.09 141.167 66.5C141.167 35.91 112.42 11.0834 77 11.0834ZM47.1625 102.521C55.5684 97.3117 65.835 94.2084 77 94.2084C88.165 94.2084 98.4317 97.3117 106.838 102.521C98.4317 107.73 88.165 110.833 77 110.833C65.835 110.833 55.5684 107.73 47.1625 102.521ZM116.398 94.8734C105.159 87.2576 91.286 83.1184 77 83.1184C62.7141 83.1184 48.8412 87.2576 37.6017 94.8734C29.8819 86.9229 25.6558 76.876 25.6667 66.5C25.6667 42.0059 48.6384 22.1667 77 22.1667C105.362 22.1667 128.333 42.0059 128.333 66.5C128.333 77.3063 123.842 87.1705 116.398 94.8734Z",
    fill: "#BA8108"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33.25C64.6158 33.25 54.5416 41.9504 54.5416 52.6458C54.5416 63.3413 64.6158 72.0417 77 72.0417C89.3841 72.0417 99.4583 63.3413 99.4583 52.6458C99.4583 41.9504 89.3841 33.25 77 33.25ZM77 60.9583C71.6741 60.9583 67.375 57.2454 67.375 52.6458C67.375 48.0463 71.6741 44.3333 77 44.3333C82.3258 44.3333 86.625 48.0463 86.625 52.6458C86.625 57.2454 82.3258 60.9583 77 60.9583Z",
    fill: "#BA8108"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.6c7121855d944a1e122d0783480d8b76.svg";
export { ForwardRef as ReactComponent };